(() => {

  const MAX = 2;

  function init(root) {

    const trigger = root.querySelector(".fp-trigger");
    const modal = root.querySelector(".fp-modal");
    const panel = root.querySelector(".fp-panel");
    const grid = root.querySelector(".fp-grid");
    const confirmBtn = root.querySelector(".fp-confirm");
    const errorBox = root.querySelector(".fp-error");
    const summaryText = root.querySelector(".fp-summary-text");

    const prop1 = root.querySelector(".fp-prop-1");
    const prop2 = root.querySelector(".fp-prop-2");
    const propAll = root.querySelector(".fp-prop-all");

    const dataEl = root.querySelector(".fp-data");
    const form = root.closest("form");
    const atcBtn = form ? form.querySelector(".fp-atc-btn") : null;

    // FIX: summary box and edit button for post-confirm display
    const summaryBox = root.querySelector(".fp-summary-box");
    const editBtn = root.querySelector(".fp-edit-btn");
    const triggerWrapper = root.querySelector(".fp-trigger-wrapper");

    if (!dataEl || !form) return;

    let data = [];
    try {
      data = JSON.parse(dataEl.textContent.trim());
    } catch (e) {
      console.warn("Fragrance picker JSON invalid", e);
      return;
    }

    let counts = {};
    data.forEach(item => counts[item.id] = 0);

    let confirmed = false;

    function totalSelected() {
      return Object.values(counts).reduce((a, b) => a + b, 0);
    }

    function lockScroll() {
      document.documentElement.classList.add("fp-scroll-lock");
      document.body.classList.add("fp-scroll-lock");
    }

    function unlockScroll() {
      document.documentElement.classList.remove("fp-scroll-lock");
      document.body.classList.remove("fp-scroll-lock");
    }

    // ---- SUMMARY BOX: show selected fragrances + Edit button ----
    function updateSummaryBox() {
      if (!summaryBox) return;

      if (confirmed && totalSelected() === MAX) {
        // Build the list of selected fragrance names
        let selected = [];
        data.forEach(item => {
          for (let i = 0; i < counts[item.id]; i++) {
            selected.push(item.title);
          }
        });

        // Show summary box, hide trigger button
        summaryBox.hidden = false;
        if (triggerWrapper) triggerWrapper.style.display = "none";

        // Update summary text inside the box
        const summarySelected = summaryBox.querySelector(".fp-summary-selected");
        if (summarySelected) {
          summarySelected.textContent = selected.join(", ");
        }

      } else {
        // Hide summary box, show trigger button
        summaryBox.hidden = true;
        if (triggerWrapper) triggerWrapper.style.display = "";
      }
    }

    function fixMobileHeight() {
      if (window.innerWidth <= 520) {
        const availableHeight = window.innerHeight - 40;
        if (panel) {
          panel.style.maxHeight = availableHeight + "px";
          panel.style.height = "auto";
        }
        modal.style.height = window.innerHeight + "px";
      } else {
        if (panel) {
          panel.style.maxHeight = "";
          panel.style.height = "";
        }
        modal.style.height = "";
      }
    }

    function syncProperties() {
      let selected = [];
      data.forEach(item => {
        for (let i = 0; i < counts[item.id]; i++) {
          selected.push(item);
        }
      });

      const f1 = selected[0]?.title || "";
      const f2 = selected[1]?.title || "";
      const combined = selected.map(x => x.title).join(", ");

      if (prop1) prop1.value = f1;
      if (prop2) prop2.value = f2;
      if (propAll) propAll.value = combined;

      if (summaryText) summaryText.textContent = combined || "No fragrances selected";
    }

    function render() {
      grid.innerHTML = data.map(item => {

        const count = counts[item.id];
        const active = count > 0;

        return `
          <div class="fp-card ${active ? "fp-selected" : ""}">
            <div class="fp-thumb">
              <img src="${item.image}" alt="${item.title}">
            </div>
            <div class="fp-name">${item.title}</div>
            <div class="fp-card-actions">
              <button
                type="button"
                class="fp-btn view-btn"
                data-view="${item.image}"
                data-view-alt="${item.title}">
                View
              </button>
              ${
                count === 0
                  ? `<button
                      type="button"
                      class="fp-btn select"
                      data-select="${item.id}"
                      ${totalSelected() >= MAX ? 'disabled' : ''}>
                      Select
                    </button>`
                  : `<div class="fp-counter">
                      <button type="button" class="fp-minus" data-minus="${item.id}">-</button>
                      <span class="fp-count">${count}</span>
                      <button type="button" class="fp-plus" data-plus="${item.id}" ${totalSelected() >= MAX ? 'disabled' : ''}>+</button>
                    </div>`
              }
            </div>
          </div>
        `;
      }).join("");
    }

    function openModal() {
      modal.hidden = false;
      // FIX: clear error message every time modal opens
      errorBox.textContent = "";
      lockScroll();
      render();
      fixMobileHeight();
    }

    function closeModal() {
      modal.hidden = true;
      if (!document.querySelector(".fp-zoom-modal.active")) {
        unlockScroll();
      }
    }

    function refresh() {
      syncProperties();
      render();
    }

    /* ---------- Zoom modal ---------- */
    let zoomModal = document.querySelector(".fp-zoom-modal");

    if (!zoomModal) {
      zoomModal = document.createElement("div");
      zoomModal.className = "fp-zoom-modal";
      zoomModal.innerHTML = `
        <div class="fp-zoom-backdrop"></div>
        <div class="fp-zoom-content" role="dialog" aria-modal="true" aria-label="Preview image">
          <img src="" alt="">
          <button type="button" class="fp-zoom-close" aria-label="Close preview">×</button>
        </div>
      `;
      document.body.appendChild(zoomModal);
    }

    const zoomImg = zoomModal.querySelector("img");
    const zoomClose = zoomModal.querySelector(".fp-zoom-close");

    function openZoom(src, alt) {
      if (!src) return;
      zoomImg.src = src;
      zoomImg.alt = alt || "";
      zoomModal.classList.add("active");
      lockScroll();
    }

    function closeZoom() {
      zoomModal.classList.remove("active");
      if (modal.hidden) {
        unlockScroll();
      }
    }

    zoomModal.addEventListener("click", (e) => {
      if (
        e.target.classList.contains("fp-zoom-modal") ||
        e.target.classList.contains("fp-zoom-backdrop")
      ) {
        closeZoom();
      }
    });

    if (zoomClose) {
      zoomClose.addEventListener("click", closeZoom);
    }

    /* popup clicks */
    modal.addEventListener("click", (e) => {

      if (e.target.closest("[data-fp-close]")) {
        closeModal();
        return;
      }

      const viewBtn = e.target.closest("[data-view]");
      if (viewBtn) {
        e.preventDefault();
        e.stopPropagation();
        openZoom(
          viewBtn.getAttribute("data-view"),
          viewBtn.getAttribute("data-view-alt")
        );
        return;
      }

      const select = e.target.closest("[data-select]");
      if (select) {
        const id = select.dataset.select;
        if (totalSelected() < MAX) {
          counts[id] = 1;
          confirmed = false;
          refresh();
        }
        return;
      }

      const plus = e.target.closest("[data-plus]");
      if (plus) {
        const id = plus.dataset.plus;
        if (totalSelected() < MAX) {
          counts[id]++;
          confirmed = false;
          refresh();
        }
        return;
      }

      const minus = e.target.closest("[data-minus]");
      if (minus) {
        const id = minus.dataset.minus;
        if (counts[id] > 0) {
          counts[id]--;
          confirmed = false;
          refresh();
        }
        return;
      }

    });

    /* confirm */
    confirmBtn.addEventListener("click", (e) => {
      e.preventDefault();

      if (totalSelected() !== MAX) {
        errorBox.textContent = `Please select ${MAX} fragrances`;
        return;
      }

      confirmed = true;
      syncProperties();
      closeModal();

      // FIX: show summary box with Edit button after confirming
      updateSummaryBox();

      if (form.dataset.fpPendingSubmit === "true") {
        form.dataset.fpPendingSubmit = "false";
        HTMLFormElement.prototype.submit.call(form);
      }
    });

    // FIX: Edit button reopens modal with existing selections intact
    if (editBtn) {
      editBtn.addEventListener("click", () => {
        confirmed = false;
        updateSummaryBox();
        openModal();
      });
    }

    /* add to cart */
    const requireConfirm = (e) => {
      syncProperties();

      if (totalSelected() === MAX && confirmed) {
        return;
      }

      e.preventDefault();
      e.stopPropagation();

      if (typeof e.stopImmediatePropagation === "function") {
        e.stopImmediatePropagation();
      }

      form.dataset.fpPendingSubmit = "true";
      openModal();
      errorBox.textContent = `Please select ${MAX} fragrances`;
    };

    form.addEventListener("submit", requireConfirm, true);

    if (atcBtn) {
      atcBtn.addEventListener("click", requireConfirm, true);
    }

    /* trigger */
    trigger.addEventListener("click", openModal);

    /* resize support */
    window.addEventListener("resize", () => {
      if (!modal.hidden) {
        fixMobileHeight();
      }
    });

    /* esc support */
    document.addEventListener("keydown", (e) => {
      if (e.key !== "Escape") return;
      if (zoomModal.classList.contains("active")) {
        closeZoom();
        return;
      }
      if (!modal.hidden) {
        closeModal();
      }
    });

    /* init */
    syncProperties();
    render();
    updateSummaryBox();
  }

  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll("[data-fp-root]").forEach(init);
  });

})();